module.exports = __webpack_public_path__ + "img/ico058.b16d269e.svg";